import {BaseSpringServiceCB} from '@aiknow-srl/aik-angular-sdk';
import {KeyVal} from '../../Models/Common/KeyVal';
import {UserOPEEnum} from "./UserOPEEnum";

class LocaleDTO {
  /**
   * Language locale
   */
  locale?: string;
  /**
   * Country flag
   */
  countryFlag?: string;
}

class MenuDTO {
  /**
   * id
   */
  id?: string;
  /**
   * Name of the component
   */
  path?: string;
  /**
   * icon
   */
  icon?: string;
}

class PostLoginUserDTO {
  /**
   * Username of logged customerUser
   */
  email?: string;
  /**
   * First Name of logged customerUser
   */
  firstname?: string;
  /**
   * Last Name of logged customerUser
   */
  lastname?: string;
  /**
   * Roles of logged customerUser
   */
  roles?: string[];
  /**
   * List of menuItems items
   */
  menuItems?: MenuDTO[];
}

/**
 * O Inner Class
 */
class O {

  /**
   * Application ID
   */
  appId!: string;
  /**
   * Environment type
   */
  envId!: string;
  /**
   * Versione corrente dell'applicazione
   */
  appVersion!: string;
  /**
   * Environment Label type
   */
  envIdLabel!: string;
  /**
   * Flag che indica se il servizio di OSM è abilitato o meno
   */
  osmEnabled!: boolean;
  /**
   * Logged User
   */
  user!: PostLoginUserDTO;
  /**
   * Languages list
   */
  localeList!: LocaleDTO[];

  deviceTypesEnum!: KeyVal[];
  assetTypesEnum!: KeyVal[];

  deviceRegistryStatusEnum!: KeyVal[];

}

/**
 * I Inner Class
 */
class I {

}

/**
 * GetTransportItemDetailCB class
 */
export class PostLoginCB extends BaseSpringServiceCB {
  /**
   * Input
   */
  public i: I;
  /**
   * Output
   */
  public o: O;

  /**
   * Class constructor
   */
  constructor() {
    super(UserOPEEnum.PostLogin);
    this.i = new I();
    this.o = new O();
  }

}
